import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';
import { Row, Col, ButtonToolbar, Button } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import Selection from '../Common/selection';
import ContentWrapper from '../Layout/ContentWrapper';

class EditCustomerModal extends Component {
  componentDidMount() {
    this.props.fetchCustomers();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.deliverCustomerId && nextProps.deliverCustomerId != this.props.deliverCustomerId) {
      this.props.fetchCustomerDetail(nextProps.deliverCustomerId.value);
    }
    if (nextProps.siCustomerEdited !== this.props.siCustomerEdited && nextProps.siCustomerEdited === true) {
      this.props.confirmAction();
    }
  }

  componentWillUnmount() {
    this.props.resetEditSICustomer();
  }

  getCustomerNameOptions() {
    const customerOptions = [];
    this.props.customers.map((customer) => {
      customerOptions.push({ value: customer.Customer_id, label: customer.Name });
    });
    return customerOptions;
  }

  getCustomerNumOptions() {
    const customerOptions = [];
    this.props.customers.map((customer) => {
      customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum });
    });
    return customerOptions;
  }

  getCustomerShippingAddressOptions() {
    const customerShippingAddressOptions = [];
    if (this.props.currentCustomerDetail && this.props.currentCustomerDetail.Shipping) {
      this.props.currentCustomerDetail.Shipping.map((shipping) => {
        const address = `${shipping.Street} ${shipping.City} ${shipping.State} ${shipping.Zip}`;
        customerShippingAddressOptions.push({ value: shipping.CustomerDetail_id, label: address });
      });
    }
    return customerShippingAddressOptions;
  }

  handleFormSubmit = (formProps) => {
    if (!this.checkPermission('add_purchase_order')) {
      const Deliver_Customer_id = formProps.Deliver_Customer_id.value;
      const Deliver_CustomerDetail_id = formProps.CustomerDetail_id && formProps.CustomerDetail_id.value;
      this.props.editSICustomer(this.props.invoiceID, { Deliver_Customer_id, Deliver_CustomerDetail_id });
    } else {
      alert('You have no permission!');
    }
  }

  checkPermission(permission) {
    return false;
  }

  renderCustomers() {
    if (this.props.customersIsLoading) {
      return <Spinner />;
    } // If payment term is loading, show a spinner.

    const customerNameOptions = this.getCustomerNameOptions();
    const customerNumOptions = this.getCustomerNumOptions();
    return (
      <div>
        <Row className="mb-lg">
          <Col sm={12}>
            <label htmlFor="Deliver_Customer_id" className="col-sm-3"><Translate value="customer_name" />:</label>
            <Col sm={4}>
              <Field name="Deliver_Customer_id" component={Selection} options={customerNameOptions} />
            </Col>
          </Col>
        </Row>
        <Row className="mb-lg">
          <Col sm={12}>
            <label htmlFor="Deliver_Customer_id" className="col-sm-3"><Translate value="customer_no" />:</label>
            <Col sm={4}>
              <Field name="Deliver_Customer_id" component={Selection} options={customerNumOptions} />
            </Col>
          </Col>
        </Row>
      </div>
    );
  }

  renderCustomerShippingAddress() {
    if (this.props.detailIsLoading) {
      return <Spinner />;
    } // If payment term is loading, show a spinner.

    const customerShippingAddressOptions = this.getCustomerShippingAddressOptions();
    return (
      <div>
        <Row className="mb-lg">
          <Col sm={12}>
            <label htmlFor="CustomerDetail_id" className="col-sm-3"><Translate value="shipping_address" />:</label>
            <Col sm={9}>
              <Field name="CustomerDetail_id" component={Selection} options={customerShippingAddressOptions} />
            </Col>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const { handleSubmit, submitting, pristine, siCustomerIsEditing, siCustomerEdited } = this.props;
    return (
      <form>
        <ContentWrapper>
          <Row>
            <Col xs={12}>
              { this.renderCustomers() }
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              { this.renderCustomerShippingAddress() }
            </Col>
          </Row>
          <Row className="centerStyle">
            <Button
              className="mr"
              bsStyle="success"
              type="button"
              disabled={submitting || pristine || siCustomerIsEditing || siCustomerEdited}
              onClick={handleSubmit(this.handleFormSubmit)}
            >
              <em className={`fa ${siCustomerIsEditing ? 'fa-spinner fa-spin' : 'fa-save'}`} />
              <Translate value="save" />
            </Button>
            <Button
              bsStyle="danger"
              type="button"
              onClick={this.props.onCloseClicked}
            >
              <em className="fa fa-close" />
              <Translate value="cancel" />
            </Button>
          </Row>
        </ContentWrapper>
      </form>
    );
  }
}

export default EditCustomerModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/EditCustomerModal.jsx